// TODO: delete if not being used
import React from "react"
import "./PRSUploadErrorMessages.scss"

// Components
import { PrimeButton } from "components-design-system"

const PRSUploadErrorMessages = ({ setOpenModal, data }) => {
  return (
    <div>
      <div className="prs-error-modal-body">
        <div className="prs-upload-error-container">
          {data &&
            data.map((item) => {
              return <ErrorItem data={item} />
            })}
        </div>
      </div>
      <div className="prs-upload-actoin-container">
        <PrimeButton
          onClick={() => setOpenModal(false)}
          style={{ marginRight: 16 }}
        >
          Cancel
        </PrimeButton>
        <PrimeButton type="primary">Save Changes</PrimeButton>
      </div>
    </div>
  )
}

export default PRSUploadErrorMessages

const ErrorItem = ({ data }) => {
  return (
    <div className="prs-error-item-container">
      <div className="prs-error-info-container">
        <div
          className="prs-upload-text"
          style={{ marginBottom: 10 }}
        >
          {data && data.study_id}
        </div>
        {data &&
          data.discrepencies.map((item, i) => {
            return (
              <div
                className="prs-upload-discrepency-item"
                key={item.title + "-" + i + "-discrepency"}
              >
                <div
                  className="prs-upload-error-label"
                  style={{ marginRight: 26 }}
                >
                  {item.title}
                </div>
                <div className="prs-upload-text">{item.value}</div>
              </div>
            )
          })}
        <div className="prs-upload-error">
          <i
            style={{
              color: "#D7542C",
              marginRight: 7,
            }}
            className="fas fa-exclamation-circle"
          />
          {data &&
            data.discrepencies.map((item, i) => {
              return (
                <div
                  className="prs-upload-error-text"
                  style={{ color: "#D7542C" }}
                >
                  {item.error}
                  {data.discrepencies.length > i && ","}
                </div>
              )
            })}
        </div>
      </div>

      <div className="prs-error-action-container">
        <a>Update</a>
      </div>
    </div>
  )
}
